export function profileSubscribe() {
    const $profile = document.querySelector('.profile');

    if (!$profile) return;

    let $subscribeBox = $profile.querySelector('.subscribe');

    $subscribeBox.addEventListener('change', (event) => {
        if (event.currentTarget.checked) {
           fetch('profile/subscribe?subscribed=true');
        } else {
           fetch('profile/subscribe?subscribed=false');
        }
    });
}

export function profileDelete() {
    const $profile = document.querySelector('.profile');

    if (!$profile) return;

    const $email = btoa(document.querySelector('.email').innerHTML);
    let $requestCode = $profile.querySelector('.request-code');
    let $resendCode = $profile.querySelector('.resend-code');

    $requestCode.addEventListener('click', (event) => {
       event.preventDefault();
       fetch(`/profile/delete?email=${$email}`)
           .then(response => {
               if (response.status === 200) {
                   $requestCode.classList.add('hidden');
                   $profile.querySelector('.dialog').classList.remove('hidden');
               }
           });
    });

    $profile.querySelector('.confirmation-submit').addEventListener('click', (event) => {
        event.preventDefault();
        let $confirmationCode = btoa($profile.querySelector('.confirmation-code').value);

        if (!$confirmationCode.trim().length) {
            $profile.querySelector('.dialog .error').classList.remove('hidden');
        }

        if (!!$confirmationCode.trim().length) {
            fetch(`/profile/delete?email=${$email}&password=${$confirmationCode}`)
                .then(response => {
                    if (response.status === 200) {
                        $profile.querySelector('.dialog .error').classList.add('hidden');
                        location.href = '/';
                    } else {
                        $profile.querySelector('.dialog .error').classList.remove('hidden');
                    }
                });
        }
    });

    $resendCode.addEventListener('click', (event) => {
        event.preventDefault();
        fetch(`/profile/delete?email=${$email}`)
            .then(response => {
                if (response.status === 200) {
                    $profile.querySelector('.confirmation-code').value = '';

                    if (!$profile.querySelector('.dialog .error').classList.contains('hidden')) {
                        $profile.querySelector('.dialog .error').classList.add('hidden');
                    }
                }
            });
    });

    $profile.querySelector('.logout').addEventListener('click', (event) => {
        event.preventDefault();

        fetch('/profile/logout')
            .then(response => {
                if (response.status === 200) {
                    location.href = '/';
                }
            });
    });
}